import { render, staticRenderFns } from "./WorkflowGrid.vue?vue&type=template&id=4c7827bc&scoped=true"
import script from "./WorkflowGrid.vue?vue&type=script&lang=ts"
export * from "./WorkflowGrid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7827bc",
  null
  
)

export default component.exports